<template>
  <div>
    <div class="w-full vx-col mb-base">
      <vs-card title="Add New Customer" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
           <div class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-left">
              <h4>Update SAP Area</h4>
          </div>
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
            <vs-button color="primary" class="mb-4 mr-1 btn md:mb-0" @click="submitForm">Process</vs-button>

            </div>
        </div>
        <div class="mt-6 vx-row">
          <div class="w-full vx-col md:w-1/3">

            <label class="vs-input--label">No Reference</label>
            <vs-input class="w-full" v-model="reference" />

          </div>
        </div>

        <div class="mt-6 vx-row">
          <div class="w-full vx-col md:w-1/3">

            <label class="vs-input--label">SAP Area Code</label>
            <vs-select
                class="selectExample"
                v-model="sap_area_code"
                width="100%"
                autocomplete
                @input-change="searchArea($event)">
                <vs-select-item v-for="(item, index) in sapAreaOptions" :key="index" :value="item.id" :text="item.label"/>
            </vs-select>

          </div>
        </div>

        <div class="mt-6 vx-row">
          <div class="w-full vx-col md:w-1/4">
            <div class="mt-1 mb-3 vx-row">
                <div class="w-2/3 vx-col">
                    Update Area Customer
                </div>
                <div class="w-1/3 vx-col">
                    <vs-checkbox v-model="area_customer"></vs-checkbox>
                </div>
            </div>

          </div>
        </div>

        <div class="mt-6 vx-row">
          <div class="w-full vx-col md:w-1/4">
            <div class="mt-1 mb-3 vx-row">
                <div class="w-2/3 vx-col">
                    Update Area Transport Order
                </div>
                <div class="w-1/3 vx-col">
                    <vs-checkbox v-model="area_transport"></vs-checkbox>
                </div>
            </div>

          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  data() {
    return {
      isLoading: false,
      isForm: false,
      file:null,
      sap_area_code:null,
      area_customer: false,
      area_transport: false,
      sapAreaOptions: [],
      reference:"",
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    submitForm() {
      if(this.reference == ''){
        this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "No Reference is required"
          });

          return false;
      }


      if(this.sap_area_code == ''){
        this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "SAP Area is required"
          });

          return false;
      }
      this.isLoading = true;
      this.$http.post("support/update_sap_area", {
          reference: this.reference,
          sap_area: this.sap_area_code,
          area_customer: this.area_customer,
          area_transport: this.area_transport,
      })
      .then(res => {
          this.isLoading = false;
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
              color: "success",
              title: "Success",
              iconPack: "feather",
              icon: "icon-check",
              text: message
          });

          setTimeout(() => {
              window.location.reload()
          }, 200);
      })
      .catch(error => this.handleError(error));
    },
    searchArea(e) {
        if(e.target.value.length > 3){
            const data = {
                area: e.target.value
            }
            this.$http.post('master/get_sap_area', data)
            .then(res => {
                console.log(res.data.data);
                this.sapAreaOptions = res.data.data
            })
            .catch((error) => {
                console.log(error)
            })
        }
    },
  },
  mounted() {
  }
};
</script>
